import { useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from 'routes/route-paths';

const getAccountDetailRoute = (companyId: number) => {
  return `/${ROUTE_PATHS.ACCOUNTS}/${ROUTE_PATHS.ACCOUNT_DETAIL.replace(
    ':accountId',
    companyId.toString() ?? '',
  )}`;
};
const getPeopleBaseRoute = (companyId: number) => {
  return `${getAccountDetailRoute(companyId)}/${ROUTE_PATHS.ACCOUNT_DETAIL_PEOPLE}`;
};
const getPeopleListRoute = (companyId: number) => {
  return `${getPeopleBaseRoute(companyId)}/${ROUTE_PATHS.ACCOUNT_DETAIL_PEOPLE_LIST}`;
};
const getPeopleGridRoute = (companyId: number) => {
  return `${getPeopleBaseRoute(companyId)}/${ROUTE_PATHS.ACCOUNT_DETAIL_PEOPLE_BOARD}`;
};
const getPeopleDetailRoute = (companyId: number, userId: number) => {
  return `${getPeopleBaseRoute(companyId)}/${ROUTE_PATHS.ACCOUNT_DETAIL_PEOPLE_DETAIL.replace(':userId', userId.toString())}`;
};

export const useAccountPeopleRouteNavigation = () => {
  const navigate = useNavigate();

  const navigateToPeopleList = (companyId: number) => {
    navigate(getPeopleListRoute(companyId));
  };
  const navigateToPeopleGrid = (companyId: number) => {
    navigate(getPeopleGridRoute(companyId));
  };
  const navigateToPeopleDetail = (companyId: number, userId: number) => {
    navigate(getPeopleDetailRoute(companyId, userId));
  };

  return {
    navigateToPeopleList,
    navigateToPeopleGrid,
    navigateToPeopleDetail,
    getPeopleListRoute,
    getPeopleGridRoute,
    getPeopleDetailRoute,
  };
};
